import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Transformation } from '../components/Transformation';
import { Method } from '../components/Method';
import { WhyOthersFail } from '../components/WhyOthersFail';
import { Story } from '../components/Story';
import { Testimonials } from '../components/Testimonials';
import { PurchaseSection } from '../components/PurchaseSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-294">
      <Hero data-id="element-295" />
      <PainPoints data-id="element-296" />
      <Transformation data-id="element-297" />
      <Method data-id="element-298" />
      <WhyOthersFail data-id="element-299" />
      <Story data-id="element-300" />
      <Testimonials data-id="element-301" />
      <PurchaseSection data-id="element-302" />
      <FinalCTA data-id="element-303" />
      <Footer data-id="element-304" />
    </main>;
}